import { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from "react";
import { NavbarItemIcon, NavbarItemIconProps } from "./NavbarItemIcon";

import { LtIcons } from "@landtechnologies/icons/font/lt-icons";
import { NavbarItemDesktop } from "./NavbarItemDesktop";
import clsx from "clsx";

export interface NavbarItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  anchorActive?: boolean;
  leadIcon?: `${LtIcons}`;
  leadIconProps?: Omit<NavbarItemIconProps, "icon">;
  tailIcon?: `${LtIcons}`;
  mobile?: boolean;
  mobileContextMenu?: boolean;
  menuItem?: ReactNode;
  title?: string;
}

export const NavbarItem = ({
  active,
  anchorActive,
  children,
  leadIcon,
  tailIcon,
  mobile,
  mobileContextMenu = false,
  menuItem,
  title,
  ...rest
}: NavbarItemProps) => {
  if (!mobile) {
    return (
      <NavbarItemDesktop active={active} leadIcon={leadIcon} tailIcon={tailIcon} anchorActive={anchorActive} {...rest}>
        {children}
      </NavbarItemDesktop>
    );
  }
  if (mobileContextMenu) {
    return (
      <NavbarContextMenuButtonItemMobile
        menuItem={menuItem}
        title={title ?? ""}
        {...(rest as HTMLAttributes<HTMLDivElement>)}
      />
    );
  }
  return (
    <NavbarItemMobile active={active} leadIcon={leadIcon} {...rest}>
      {children}
    </NavbarItemMobile>
  );
};

export const NavbarItemMobile = ({ active, children, leadIcon, leadIconProps = {}, ...rest }: NavbarItemProps) => {
  return (
    <button
      {...rest}
      className={clsx("flex flex-col items-center w-full", active && "text-text-base-active")}
      aria-current={active}
    >
      {leadIcon && <NavbarItemIcon icon={leadIcon} {...leadIconProps} />}
      <span className="text-xs">{children}</span>
    </button>
  );
};

export const NavbarContextMenuButtonItemMobile = ({
  menuItem,
  title,
  ...rest
}: { menuItem: ReactNode; title: string } & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className="flex flex-col items-center w-full" {...rest}>
      {menuItem}
      <span className="text-xs">{title}</span>
    </div>
  );
};
